import { useMemo } from 'react'

import { isAuthenticated } from '../../../../domain'
import {
  AnonymousCondition,
  DisclosureSectionCondition,
} from '../../../../state/configuration'
import { usePrincipal, useProposer } from '../../../authentication'

export const useAnonymousCondition = () => {
  const { proposer } = useProposer()
  const principal = usePrincipal()

  return useMemo(
    () => (condition: AnonymousCondition) =>
      isAuthenticated(proposer, principal) !== condition.isAnonymousOnly,
    [proposer],
  )
}

export const useSectionConditions = () => {
  const anonymousCondition = useAnonymousCondition()

  return useMemo(
    () => (it: DisclosureSectionCondition) => {
      switch (it.type) {
        case 'anonymous':
          return anonymousCondition(it as AnonymousCondition)
      }
    },
    [anonymousCondition],
  )
}
